import React from 'react';
import { useParams } from 'react-router-dom';

import Layout from '../../../components/layout/Layout';
import Reward from '../../../components/reward/AdminReward';
import AnalyticsWrapper from '../../../components/common/AnalyticsWrapper';

const RewardView = () => {
  const { id } = useParams();

  return (
    <AnalyticsWrapper>
      <Layout title="Reward">
        <Reward id={id} />
      </Layout>
    </AnalyticsWrapper>
  );
};

export default RewardView;
